/* vault-player.js — Canvas-only build for Shopify */
(function () {
  if (window.__vaultPlayerBound) return;
  window.__vaultPlayerBound = true;

  const TRACKS = [
    {
      url: "https://cdn.shopify.com/s/files/1/0892/5508/4359/files/HEAVY_REESE_SERUM_2.wav?v=1746568114",
      name: "HEAVY_REESE_SERUM_2",
      artist: "Neuro Drum & Bass Vol. 1",
      artwork: "https://cdn.shopify.com/s/files/1/0892/5508/4359/files/neurodnb.jpg?v=1760819887"
    }
  ];

  function ready(fn) {
    document.readyState !== "loading"
      ? fn()
      : document.addEventListener("DOMContentLoaded", fn);
  }

  function init() {
    if (!window.WaveSurfer || typeof WaveSurfer.create !== "function") {
      console.error("❌ WaveSurfer not detected globally");
      return;
    }

    console.log("🎧 Vault Player initialized");

    const playlist = document.querySelector("#vaultPlaylist");
    const art = document.querySelector(".vault-player__art");
    const title = document.querySelector(".vault-player__title");
    if (!playlist) return;

    playlist.innerHTML = "";

    TRACKS.forEach((t, i) => {
      const row = document.createElement("div");
      row.className = "vp-row";
      row.dataset.index = i;

      const play = document.createElement("button");
      play.className = "vp-row__play";
      play.textContent = "▶";
      row.appendChild(play);

      const meta = document.createElement("div");
      meta.className = "vp-row__meta";
      meta.innerHTML = `<p class='vp-row__name'>${t.name}</p><p class='vp-row__artist'>${t.artist}</p>`;
      row.appendChild(meta);

      const wave = document.createElement("div");
      wave.className = "vp-row__wave";
      wave.id = `vp-wave-${i}`;
      row.appendChild(wave);

      playlist.appendChild(row);
    });

    const waves = [];
    let current = -1;

    TRACKS.forEach((t, i) => {
      const ws = WaveSurfer.create({
        container: `#vp-wave-${i}`,
        waveColor: "#cccccc",
        progressColor: "#facc15",
        cursorColor: "#facc15",
        height: 52,
        barWidth: 2,
        barGap: 1,
        normalize: true,
        interact: true,
        backend: "MediaElement", // Use direct <audio> backend for stability
        plugins: []
      });

      ws.on("ready", () => {
        console.log("✅ ready:", t.name);
      });

      ws.on("error", (e) => console.error("WaveSurfer error:", e));

      ws.on("finish", () => {
        const row = document.querySelector(`.vp-row[data-index="${i}"]`);
        if (row) {
          row.classList.remove("vp-row--active");
          const btn = row.querySelector(".vp-row__play");
          if (btn) btn.textContent = "▶";
        }
      });

      ws.load(t.url);
      waves[i] = ws;
    });

    // --- Playlist Controls ---
    document.querySelectorAll(".vp-row").forEach((row) => {
      const i = parseInt(row.dataset.index, 10);
      const btn = row.querySelector(".vp-row__play");

      btn.addEventListener("click", () => {
        if (!waves[i]) return;

        if (waves[i].isPlaying && waves[i].isPlaying()) {
          waves[i].pause();
          btn.textContent = "▶";
          row.classList.remove("vp-row--active");
        } else {
          waves.forEach((w, j) => {
            if (j !== i && w.isPlaying && w.isPlaying()) {
              w.pause();
              const other = document.querySelector(`.vp-row[data-index="${j}"]`);
              if (other) {
                other.classList.remove("vp-row--active");
                const ob = other.querySelector(".vp-row__play");
                if (ob) ob.textContent = "▶";
              }
            }
          });
          waves[i].play();
          btn.textContent = "❚❚";
          row.classList.add("vp-row--active");
          if (art) art.src = TRACKS[i].artwork;
          if (title) title.textContent = TRACKS[i].name;
          current = i;
        }
      });
    });

    // Ensure visible waveform
    window.addEventListener("load", () => {
      setTimeout(() => {
        document.querySelectorAll("canvas").forEach((c) => {
          c.style.display = "block";
          c.style.opacity = "1";
        });
      }, 800);
    });
  }

  ready(init);
  document.addEventListener("shopify:section:load", init);
  document.addEventListener("shopify:section:select", init);
})();
